export const levelLabels = {
  easy: 'easy',
  normal: 'medium',
  difficult: 'hard',
};

export function getLevelLabel(level) {
  return level ? levelLabels[level] : null;
}
